module.exports = __webpack_public_path__ + "img/cart-masterclass-bottle-paid.f0155dcc.png";